import RecibosPostulacionPendientes from "./componentes/RecibosPostulacionPendientes";
import "./App.css";
import Topbar from "./seccions/topbar/Topbar";
import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import DetalleTramite from "./pages/detalleTramite/DetalleTramite";
import Iniciados from "./pages/iniciados/Iniciados";
import { UsuarioProvider, useUsuario } from "./context/UsuarioContext";
import toast, { Toaster } from "react-hot-toast";
import Recibidos from "./pages/recibidos/Recibidos";
//import { URL_API } from './config/configBase';
import Postulacion from "./pages/postulacion/Postulacion";
import ModalLoad from "./componentes/ModaLoad";
import FueraDeLinea from "./pages/fueraDeLinea/FueraDeLinea";
import Procesados from "./pages/procesados/Procesados";
import AprocesarFuturo from "./pages/procesados/AprocesarFuturo";
import { onMessageListener, requestForToken } from "./config/firebase";
import { toastNotificacion } from "./functions/alertas";
import { IoAlertCircle } from "react-icons/io5";
import ModalRegistrarPersona from "./componentes/ModalRegistrarUsuario";
import Login2 from "./pages/login/Login2";
import LoginGoogle2 from "./pages/login/LoginGoogle2";
import { isSupported } from "firebase/messaging";
import LoginGoogle3 from "./pages/login/LoginGoogle3";
import MatriculacionPage from "./pages/matriculacion/MatriculacionPage";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
  <UsuarioProvider>
    <App></App>
    <div>
      <Toaster />
    </div>
  </UsuarioProvider>
);

function App() {
  /*
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        // Realizar una solicitud a un enlace específico (puedes cambiarlo según tus necesidades)
        const response = await fetch(URL_API);

        // Verificar si la solicitud fue exitosa (código de respuesta 2xx)
        if (response.ok) {
          setIsOnline(true);
        } else {
          setIsOnline(false);
        }
      } catch (error) {
        // Error al realizar la solicitud, asumimos que no hay conexión
        setIsOnline(false);
      }
    };

    // Verificar la conexión inicialmente
    checkConnection();

    // Configurar un temporizador para verificar la conexión periódicamente
    const intervalId = setInterval(checkConnection, 5000); // Verificar cada 5 segundos

    // Limpiar el temporizador al desmontar el componente
    return () => clearInterval(intervalId);
  }, []);

*/
  async function iniciar() {
    const soportado = await isSupported();

    if (!soportado) {
      console.warn("Firebase Messaging no es compatible con este navegador.");
      return;
    }

    // ✅ Solo llega aquí si el navegador es compatible (Android, desktop, etc.)
    solicitarPermisoNotifiacion();

    onMessageListener()
      .then((payload) => {
        console.log("📩 Llegó mensaje push:", payload);
        toastNotificacion(payload?.notification?.title, payload?.notification?.body);
      })
      .catch((err) => console.log("❌ Fallo al escuchar mensajes:", err));
  }

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    iniciar();

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const { token, setTkApp } = useUsuario();

  function solicitarToken() {
    requestForToken().then((tk) => {
      if (tk !== null) {
        console.log("::::tk recibido::::");
        setTkApp(tk);
      }
    });
  }

  function solicitarPermisoNotifiacion() {
    if (Notification.permission === "granted") {
      solicitarToken();
    } else if (Notification.permission === "denied") {
      showBlockedToast();
      console.log("El permiso de notificaciones está bloqueado.");
    } else {
      // El estado es 'default', solicita el permiso al usuario
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          solicitarToken();
        } else {
          showBlockedToast();
          console.log("El usuario no concedió el permiso.");
        }
      });
    }
  }

  const showBlockedToast = () => {
    toast.custom((t) => (
      <div
        className={`toast show ${t.visible ? "fade show" : "fade"}`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ maxWidth: "24rem" }}
      >
        <div className="toast-header">
          <div>
            <IoAlertCircle className="fs-3 me-2 text-warning" />
          </div>
          <strong className="me-auto">Notificaciones bloqueadas</strong>
        </div>
        <div className="toast-body">Activa las notificaciones en la configuración del navegador.</div>
      </div>
    ));
  };

  if (!isOnline) {
    return <FueraDeLinea />;
  }

  if (!token) {
    return (
      <div className="m">
        <Routes basename={"/"}>
          <Route exact path="/*" element={<Login2 />} />
          <Route exact path="/postulacion" element={<LoginGoogle2 />} />
          <Route exact path="/matriculacion" element={<LoginGoogle3 />} />
        </Routes>
        <ModalLoad style={{ zIndex: "1055" }} />
      </div>
    );
  }

  return (
    <div className="App">
      <RecibosPostulacionPendientes />
      <Topbar></Topbar>

      <div className="" style={{ marginTop: "50px" }}>
        <Routes>
          <Route exact path="/*" element={<Home />} />
          <Route exact path="/tramite/detalle" element={<DetalleTramite />} />
          <Route exact path="/iniciados" element={<Iniciados />} />
          <Route exact path="/recibidos" element={<Recibidos />} />
          <Route exact path="/procesados" element={<Procesados />} />
          <Route exact path="/AprocesarFuturo" element={<AprocesarFuturo />} />
          <Route exact path="/postulacion" element={<Postulacion />} />
          <Route exact path="/matriculacion" element={<MatriculacionPage />} />
        </Routes>
        <ModalRegistrarPersona />
      </div>
      <ModalLoad style={{ zIndex: "1055" }} />
    </div>
  );
}
